import React from 'react';

export default function Notice({ num, title, data, date, img, count, openModal  }) {
  return (
    <div className="w-full border-b">
      <button
        className="flex items-center w-full text-lg text-left h-14"
        onClick={openModal}
      >
        <p className="w-1/6 text-center">{num}</p>
        <p className="w-3/6 text-center">{title}</p>
        <p className="w-1/6 text-center">{date}</p>
        <p className="w-1/6 text-center">{count}</p>
      </button>
    </div>
  );
}
